import { FamilyPlanTypes } from '../common/services/package/package.model';
import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';
import FamilyPlanService from './famil-plan.service';

export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('familyPlan', {
    component: 'fizyPaycellFamilyPlan',
    parent: 'mainWrapper',
    resolve: {
      invoice: [
        '$q',
        'globalSpinner',
        'familyPlanService',
        '$state',
        ($q, globalSpinner: GlobalSpinnerService, familyPlanService: FamilyPlanService, $state) => {
          globalSpinner.start();
          familyPlanService.userHasFamilyPackage().then(result => {
            if(!result.family){
              $state.go("myAccount");
            }
          });
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.FAMILY; }]
    },
    url: '/family-plan'
  });
  $stateProvider.state('duoPlan', {
    component: 'fizyPaycellFamilyPlan',
    parent: 'mainWrapper',
    resolve: {
      invoice: [
        '$q',
        'globalSpinner',
        'familyPlanService',
        '$state',
        ($q, globalSpinner: GlobalSpinnerService, familyPlanService: FamilyPlanService, $state) => {
          globalSpinner.start();
          familyPlanService.userHasFamilyPackage().then(result => {
            if(!result.duo){
              $state.go("myAccount");
            }
          });
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.DUO; }]
    },
    url: '/duo-plan'
  });
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan.routes.ts